module.exports = __webpack_public_path__ + "img/strategy-document.91a56f89.svg";